export default "__VITE_ASSET__CLZkbb0B__"